export const powerOffIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.6" d="M4.5 5.43a5 5 0 1 0 7 0M8 2v5m4.8 5.8L3.2 3.2"/></svg>`,
    name: 'power-off' as const
};